import React, {
  useState,
  useEffect
} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Avatar,
  Paper,
  Chip,
  Tooltip,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  AppBar,
  Tabs,
  Tab,
  Box,
} from '@material-ui/core';
import MapIcon from '@material-ui/icons/Map';

import {StaticMap} from './StaticMap';
import localization from '../../../utils/localizations';
import {
  Document,
  Room
} from '../../../types';

const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
  },
  noMaxWidth: {
    maxWidth: 'none',
  },
  block: {
    display: 'block',
  },
  imageBlock: {
    display: 'block',
    width: '100%',
  },
  tabPanelContent: {
    marginTop: 10,
  }
}));
 
function TabPanel(props: any) {
  const { children, value, index, ...other } = props;
  const classes = useStyles();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className={classes.tabPanelContent}>
          <Typography>{children}</Typography>
        </div>
      )}
    </div>
  );
}

function RoomChip(props: {room: Room}) {
  const classes = useStyles();
  const [showDetail, setShowDetail] = useState(false);
  const [index, setIndex] = React.useState(0);

  return (
    <>
      <Chip
        avatar={<MapIcon />}
        label={props.room.name}
        variant="outlined"
        onClick={() => {
          setShowDetail(true)
        }}
      />
      <Dialog
        open={showDetail}
        onClose={() => setShowDetail(false)}
        aria-labelledby="room-detail-dialog-title"
        aria-describedby="room-detail-dialog-description"
      >
        <DialogTitle id="room-detail-dialog-title">{props.room.name}</DialogTitle>
        <DialogContent>
          <DialogContentText id="room-detail-dialog-description">
            {props.room.description}
          </DialogContentText>

          <AppBar position="static" color="default">
            <Tabs
              value={index}
              onChange={(event, newIndex) => setIndex(newIndex)}
              variant="scrollable"
              scrollButtons="on"
              indicatorColor="primary"
              textColor="primary"
              aria-label="scrollable force tabs example"
            >
              <Tab icon={<MapIcon />} />
              {props.room.images.map((image, i) => {
                return (
                  <Tab key={`image-btn-${i}`} icon={<img src={(image as any).thumbnail} alt="" width="32" height="32" className={classes.block} />} />
                );
              })}
            </Tabs>
          </AppBar>

          <div>
            <TabPanel value={index} index={0}>
              <StaticMap
                location={props.room.location}
                zoom={19}
                width={600}
                height={300}
                imageClassName={classes.imageBlock}
              />
            </TabPanel>
            {props.room.images.map((image, i) => {
              return (
                <TabPanel value={index} index={i+1} key={`image-full-${i}`}>
                  <img src={(image as any).medium} alt="" width="600" className={classes.imageBlock} />
                </TabPanel>
              );
            })}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDetail(false)} color="primary">
            {localization.close}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export {RoomChip};